import {
  Button,
  Box,
  Grid,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Typography,
  Divider,
  Paper,
} from '@mui/material';
import { styled } from '@mui/system';
import styles from '../roleStyles';
import Action from '../../../../Models/Roles/action';
import GenericInput from '../../../AddLocation/Components/UI/GenericInput';

interface GroupedActions {
  [groupName: string]: Action[];
}

const ActionGroupCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(3),
  boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
  borderRadius: theme.spacing(1),
  height: '100%',
}));

const RoleFormVertical = ({
  formik,
  changeActionIds,
  actions,
  isSubmitting,
}: {
  formik: any;
  changeActionIds: any;
  actions: GroupedActions;
  isSubmitting: boolean;
}) => {
  const groupNames = Object.keys(actions);

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
          <GenericInput
            name="name"
            label="Role Name"
            placeholder="Enter Role Name"
            maxLength={80}
            value={formik.values.name}
            onChange={(e: any) => formik.setFieldValue(`name`, e.target.value)}
            errorMsg={formik.touched.name && formik.errors.name ? formik.errors.name : ''}
            hasError={formik.touched.name && formik.errors.name ? true : false}
            onBlur={() => formik.setFieldTouched(`name`, true)}
            required
          />
        </Grid>

        <Grid item xs={12} md={7}>
          <GenericInput
            name="description"
            label="Role Description"
            placeholder="Enter Role Description"
            maxLength={200}
            value={formik.values.description}
            onChange={(e: any) => formik.setFieldValue(`description`, e.target.value)}
            errorMsg={
              formik.touched.description && formik.errors.description
                ? formik.errors.description
                : ''
            }
            hasError={formik.touched.description && formik.errors.description ? true : false}
            onBlur={() => formik.setFieldTouched(`description`, true)}
          />
        </Grid>

        {formik.touched.actionIds && formik.errors.actionIds && (
          <Grid item xs={12}>
            <Typography color="error">{formik.errors.actionIds}</Typography>
          </Grid>
        )}

        <Grid item xs={12}>
          <Grid container >
            {groupNames.map((groupName, index) => (
              <Grid
                item
                xs
                key={groupName}
                sx={{
                  padding: 2,
                  minWidth: 200,
                }}
              >
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                  {groupName}
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={1}>
                  {actions[groupName].map((action: Action) => (
                    <Grid item xs={12} key={action.id}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            id={`action-${action.id}`}
                            value={action.id}
                            checked={formik.values.actionIds.includes(action.id)}
                            onChange={(event) => changeActionIds(event, action.id)}
                            color="primary"
                          />
                        }
                        label={action.name}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Box sx={styles.submitButtonContainer}>
          <Button type="submit" variant="contained" sx={styles.submitButton}>
            {isSubmitting ? <CircularProgress size={28} /> : 'Save'}
          </Button>
        </Box>
        </Grid>
      </Grid>
    </form>
  );
};

export default RoleFormVertical;
